import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.split";
/* eslint-disable react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import CodeBlock from '@arcblock/ux/lib/CodeBlock';
export default function CodeBlockWrapper(_ref) {
  var children = _ref.children;

  if (!Array.isArray(get(children, '[0].props.children'))) {
    return null;
  }

  var _children$0$props = children[0].props,
      className = _children$0$props.className,
      _children$0$props$chi = _children$0$props.children,
      code = _children$0$props$chi[0];
  var language = (className || '').split('-').pop();

  if (!code) {
    return null;
  }

  return /*#__PURE__*/React.createElement(CodeBlock, {
    language: language || 'shell',
    code: code
  });
}
CodeBlock.propTypes = {
  children: PropTypes.node.isRequired
};